<template>
  <BaseWarning>
    <i18n path="warnings.missingPartnership.baseWarning" tag="span">
      <template #inPitchArea>
        <a :href="infoURLs[data.pitchArea]" target="_blank">
          {{ pitchArea }}
        </a>
      </template>
      <template #objective>
        <a :href="attackingObjectivesURL" target="_blank">
          {{ objective }}
        </a>
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {  
  props: {
    data: Object
  },

  components: { BaseWarning },

  data: function() {
    return {
      infoURLs: {
        centralAttack: "https://www.guidetofm.com/tactics/role-combinations/",
        centralMidfield: "https://www.guidetofm.com/tactics/choosing-roles-duties/3/#forward-movement-partnerships",
        rightFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
        leftFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
      },

      attackingObjectivesURL: "https://www.guidetofootball.com/tactics/attacking-objectives",
    }
  },

  computed: {
    pitchArea: function() {
      const key = `in${this.data.pitchArea.charAt(0).toUpperCase()}${this.data.pitchArea.slice(1)}`;
      return this.$t(`tactics.pitchAreas.${key}`)
    },

    objective: function () {
      const key = this.data.pitchArea.startsWith("central") ?
        this.data.pitchArea :
        'flanks';
      return this.$t(`warnings.missingPartnership.objectives.${key}`);
    },
  },
};
</script>
